<template>
    <div class="c-app">
        <TheSidebar />
        <!-- Era `CWrapper` di @coreui/vue: la classe CoreUI 3 e la stessa, il componente non serve. -->
        <div class="c-wrapper">
            <TheHeader v-if="isAuthenticated" />
            <div class="c-body">
                <main class="c-main">
                    <CContainer>
                        <!--
                            In Vue 3 `<router-view>` non puo stare dentro `<transition>`: va usato
                            lo slot con ambito, che espone il componente della rotta. Con la forma
                            precedente la transizione semplicemente non avviene, e vue-router lo
                            segnala solo come avviso in console.
                        -->
                        <router-view v-slot="{ Component }">
                            <transition name="fade" mode="out-in">
                                <component :is="Component" />
                            </transition>
                        </router-view>
                    </CContainer>
                </main>
                <TheFooter />
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./TheContainer.ts"></script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
/* In Vue 3 la classe iniziale della transizione si chiama `fade-enter-from`, non `fade-enter`. */
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
